import React from "react";
import { NavLink } from "react-router-dom";
import { DescriptiveLogo } from "../logo";
import { Box, Container, Typography, Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux"; // CHANGED: Import useDispatch
import { setSelectedService } from "../../features/services/serviceSlice"; // CHANGED: Import your action

import {
  faSnowflake,
  faBolt,
  faBuilding,
  faFaucet,
  faPaintRoller,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

// The 'to' property is removed here as it will be generated dynamically
const services = [
  {
    title: "Climatização e Ar Condicionado",
    icon: faSnowflake,
  },
  {
    title: "Serviços Elétricos",
    icon: faBolt,
  },
  {
    title: "Construção Civil",
    icon: faBuilding,
  },
  {
    title: "Hidráulica e Encanamento",
    icon: faFaucet,
  },
  {
    title: "Aplicação de Revestimentos",
    icon: faPaintRoller,
  },
  {
    title: "Instalação de Racks e Estruturas",
    icon: faWarehouse,
  },
];

const year = new Date();
const currentYear = year.getFullYear();

export default function Footer() {
  const theme = useTheme();
  const dispatch = useDispatch(); // CHANGED: Initialize useDispatch

  // CHANGED: Create a handler to dispatch the action
  const handleServiceClick = (index: number) => {
    dispatch(setSelectedService(index));
  };

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        pt: 6,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        {/* Top Section */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, 1fr)",
            },
            gap: 6,
          }}
        >
          {/* Logo & About */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <NavLink to="/" style={{ textDecoration: "none", color: "white" }}>
              <DescriptiveLogo height={12} />
            </NavLink>

            <Box flex={1}>
              <Typography
                variant="h5"
                sx={{ mt: 2, color: theme.palette.text.primary }}
              >
                Acompanhe-nos
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  mt: 1,
                  "& a": {
                    color: theme.palette.primary.main,
                    fontSize: "1.4rem",
                    transition: "color 0.3s ease",
                    "&:hover": {
                      // CHANGED: Hover color updated to secondary for consistency
                      color: theme.palette.secondary.main,
                    },
                  },
                }}
              >
                <NavLink
                  to="https://web.facebook.com/profile.php?id=100079457946565"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </NavLink>

                <NavLink to="https://instagram.com" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </NavLink>

                <NavLink
                  to="https://www.linkedin.com/company/climatropical/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </NavLink>
              </Box>
            </Box>
          </Box>

          {/* Empresa */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Empresa
            </Typography>
            <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
              {[
                { to: "/about", label: "Quem somos" },
                { to: "/contact", label: "Contactos" },
                { to: "/careers", label: "Carreiras" },
                { to: "/faq", label: "FAQs" },
              ].map((item, index) => (
                <Box key={index} component="li" sx={{ mb: 1 }}>
                  <Box
                    component={NavLink}
                    to={item.to}
                    sx={{
                      textDecoration: "none",
                      color: "text.secondary",
                      fontSize: "1rem",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        color: theme.palette.info.main,
                      },
                      "&.active": {
                        fontWeight: "bold",
                        color: theme.palette.info.main,
                      },
                    }}
                  >
                    {item.label}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Serviços */}
          <Box>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              Serviços
            </Typography>
            {services.map((service, index) => (
              <Box
                key={index}
                component={NavLink}
                to="/services"
                onClick={() => handleServiceClick(index)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 1.5,
                  fontSize: "1rem",
                  textDecoration: "none",
                  color: "text.secondary",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    color: theme.palette.info.main,
                  },
                }}
              >
                <FontAwesomeIcon
                  icon={service.icon}
                  style={{ marginRight: 8 }}
                />
                <span>{service.title}</span>
              </Box>
            ))}
          </Box>
        </Box>

        <Divider sx={{ bgcolor: "grey.700", my: 1 }} />

        {/* Bottom Section */}
        <Box textAlign="center" py={1}>
          <span style={{ color: "GrayText", fontSize: "0.8rem" }}>
            &copy; {currentYear} Climatropical. Todos os direitos reservados.
          </span>
        </Box>
      </Container>
    </Box>
  );
}
